module.exports = __webpack_public_path__ + "static/media/pro7.32564c9c.jpg";